module.exports = __webpack_public_path__ + "static/media/user.aa0ba04d.png";